import { AttachmentFile } from "@/types";

export enum EVENTS {
  STATUS_SHOW = "STATUS_SHOW",
  STATUS_HIDE = "STATUS_HIDE",

  NOTIFICATION_SHOW = "NOTIFICATION_SHOW",
  NOTIFICATION_HIDE = "NOTIFICATION_HIDE",

  FOLLOW_SUBSCRIBE_SHOW = "FOLLOW_SUBSCRIBE_SHOW",
  FOLLOW_SUBSCRIBE_HIDE = "FOLLOW_SUBSCRIBE_HIDE",
  FOLLOW_STATUS_UPDATE = "FOLLOW_STATUS_UPDATE",

  SHOW_CREATE_POST = "SHOW_CREATE_POST",
  CONTENT_FEED_UPDATED = "CONTENT_FEED_UPDATED",
  CONTENT_FEED_PURCHASE = "CONTENT_FEED_PURCHASE",
  CONTENT_FEED_PURCHASED = "CONTENT_FEED_PURCHASED",
  CONTENT_FEED_PRICE_SHOW = "CONTENT_FEED_PRICE_SHOW",
  CONTENT_FEED_PRICE_CHANGED = "CONTENT_FEED_PRICE_CHANGED",
  CONTENT_FEED_PREVIEW_SHOW = "CONTENT_FEED_PREVIEW_SHOW",
  CONTENT_FEED_PREVIEW_CHANGED = "CONTENT_FEED_PREVIEW_CHANGED",
  CONTENT_FEED_SCHEDULE_POST_SHOW = "CONTENT_FEED_SCHEDULE_POST_SHOW",

  SUBSCRIPTION_OFFER_SHOW = "SUBSCRIPTION_OFFER_SHOW",
  SUBSCRIPTION_STATUS_CHANGED = "SUBSCRIPTION_STATUS_CHANGED",

  MESSAGES_MARK_READ = "MESSAGES_MARK_READ",
  MESSAGES_MARKED_READ = "MESSAGES_MARKED_READ",
  MESSAGES_NEW_MESSAGE = "MESSAGES_NEW_MESSAGE",
  MESSAGES_UPDATE_MESSAGE = "MESSAGES_UPDATE_MESSAGE",

  MAIN_MENU_HIDE = "MAIN_MENU_HIDE",
  CALL_OUTGOING = "CALL_OUTGOING",

  BALANCE_REFILL_SHOW = "BALANCE_REFILL_SHOW",
  BALANCE_REFILL_HIDE = "BALANCE_REFILL_HIDE",
  BALANCE_REFILL_PURCHASED = "BALANCE_REFILL_PURCHASED",

  PAYMENT_START_PURCHASE = "PAYMENT_START_PURCHASE",
  PAYMENT_PURCHASED = "PAYMENT_PURCHASED",
  PAYMENT_SUBSCRIBED = "PAYMENT_SUBSCRIBED",

  SHOW_LOGIN_SIGNUP_MODAL = "SHOW_LOGIN_SIGNUP_MODAL",
  SET_TAGGED_USERS = "SET_TAGGED_USERS",

  PASTE_AI_INPUT = "PASTE_AI_INPUT",
}

export enum ROLES {
  MEMBER = "member",
  CREATOR = "creator",
  ADMIN = "admin",
}

export enum ERRORS {
  SPENDING_BALANCE = "{com.scrile.money.validation.SpendingBalanceValidator.message}",
  PAID_CALL_CREATE = "{com.scrile.paid_calls.validation.PaidCallCreateValidator.message}",
  AI_QUESTIONARY_NOT_COMPLETED = "{com.scrile.ai.questionary-not-completed.message}",
}

export const MIN_PHOTO_GALLERY_FILES = 3;
export const MAX_PHOTO_GALLERY_FILES = 100;

export const COVER_ATTACHMENT_PUBLIC_ACCESS = false;

export enum connectionStateEnum {
  EMPTY = "",
  CONNECTED = "connected",
  CONNECTING = "connecting",
  DISCONNECTED = "disconnected",
}

export enum REFERRING_TYPE {
  INDIRECT_CREATOR = "INDIRECT CREATOR",
  DIRECT_CREATOR = "DIRECT CREATOR",
  MEMBER = "MEMBER",
}

export enum TabType {
  SEPARATOR = "separator",
}
